import {Component, ChangeDetectorRef, ContentChild, ElementRef} from '@angular/core';
import { TranslateService} from "@ngx-translate/core";
import {SummaryWrapperBase} from '@app/wrappers/summary-wrapper-base';
import {AuthService} from '@services/auth.service';


@Component({
  selector: 'agr-summary-wrapper',
  templateUrl: './agr-summary-wrapper.html',
  styleUrl: './agr-summary-wrapper.scss',
  standalone: false,
})
export class AgrSummaryWrapper extends SummaryWrapperBase {

  @ContentChild('title', { read: ElementRef })  titleEl?: ElementRef;
  @ContentChild('left', { read: ElementRef })   leftEl?: ElementRef;
  @ContentChild('right', { read: ElementRef })   rightEl?: ElementRef;

  constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translate: TranslateService,
    protected  override  authService:AuthService,

  ) {
    super(cdr, translate, authService);
  }


  get hasTitle() {
    return this.titleEl;
  }

  get hasLeft() {
    return this.leftEl;
  }

  get hasRight() {
    return this.rightEl;
  }

}
